
const numeral = require('numeral');
export default function dataSourceGenerator(rawData, allShipperData) {
   let billRatePerMile = 0,
        billCount = rawData.length,
        grossBillRatePerMile = 0,
        grossBillCount = allShipperData.length;
    for (let i = 0; i < rawData.length; i++) {
        if (rawData[i]['billableRatePerMiles']) {
            billRatePerMile += parseFloat(rawData[i]['billableRatePerMiles']);
        } else {
            billCount--;
        }
    }
    for (let i = 0; i < allShipperData.length; i++) {
        let shipper = allShipperData[i]['shipper'];
        if (allShipperData[i]['billableRatePerMiles'] && (shipper !== 'Greenway Carriers')) {
            grossBillRatePerMile += parseFloat(allShipperData[i]['billableRatePerMiles']);
        } else {
            grossBillCount--;
        }
    }
    billRatePerMile /= billCount;
    grossBillRatePerMile /= grossBillCount;
    if (billRatePerMile > grossBillRatePerMile) {
        return [numeral(Number(billRatePerMile).toFixed(2)).format('$0,0.00'), "(" + Math.round(((billRatePerMile - grossBillRatePerMile) * 100)/grossBillRatePerMile) + "% more than industry)", '+'];
    } else if (billRatePerMile < grossBillRatePerMile){
        return [numeral(Number(billRatePerMile).toFixed(2)).format('$0,0.00'), "(" + Math.abs(Math.round(((billRatePerMile - grossBillRatePerMile) * 100)/grossBillRatePerMile)) + "% less than industry)", '-'];
    } else {
        return ['',''];
    }
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/avgBillRateText.js